import React, { useContext } from 'react';
import WhatsappFillIcon from 'components/lib/icons/whatsapp_fill_icon';
import FloorboardRow from './floorboard_row';
import LiveboardContext from 'components/liveboards/contexts/liveboard_context.jsx';

export default function WhatsappRow() {
  const { channel, sla } = useContext(LiveboardContext);

  const stats = channel.whatsapp;
  const callSla = sla.whatsapp;
  return (
    <FloorboardRow
      newItems={stats.currentNewMessages}
      activeItems={stats.currentOpenMessages}
      currentWait={stats.currentWait}
      sla={callSla}
      activeLabel="Open Messages"
      newLabel="New Messages"
      waitLabel="Oldest Unanswered Message"
      icon={<WhatsappFillIcon />}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/floorboard/whatsapp_row.jsx